module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img40.5cd52bc4.jpg";